<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">Transfer Purchase Info</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>
<div class="modal-body" hsDraggable="modal-dialog">
  <ul ngbNav #nav="ngbNav" class="nav-tabs">
    <li
      [ngbNavItem]="i"
      *ngFor="let tpi of tpiRowDataMap | keyvalue; let i = index"
    >
      <a ngbNavLink> {{ tpi.key }} </a>
      <ng-template ngbNavContent>
        <div class="tpi-data-table">
          <nf-table-layout
            hideTitle
            [isSectionTitle]="false"
            [autoResizeGrid]="false"
            [gridOptions]="tpiGridOptions"
            [data]="tpi.value"
            hideSearch
            hideClearAll
          >
          </nf-table-layout>
        </div>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
